<div class="npp" [class.is-dark]="isDarkMode" role="dialog" aria-labelledby="npp-title">
  <header class="npp-head">
    <span class="npp-head__icon" aria-hidden="true"><mat-icon>sailing</mat-icon></span>
    <div class="npp-head__titles">
      <h2 id="npp-title">Register new voyage</h2>
      <p>Add the vessel, voyage and client details. All fields are required.</p>
    </div>
    <button type="button" class="npp-close" (click)="cancel()" [disabled]="isSubmitting" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <form class="npp-body" (ngSubmit)="submitDateTime(true)" autocomplete="off">
    <!-- Vessel -->
    <section class="npp-section">
      <div class="npp-section__head">
        <h3 class="npp-section__title"><mat-icon>directions_boat</mat-icon>Vessel</h3>
        <button
          type="button"
          class="npp-btn-action is-disabled"
          aria-disabled="true"
          tabindex="-1"
          (click)="$event.preventDefault()"
          matTooltip="Feature under development"
          matTooltipPosition="above">
          <mat-icon>directions_boat</mat-icon>
          <span>Pick Vessel from Onboarding</span>
        </button>
      </div>
      <div class="npp-grid">
        <label class="npp-field npp-field--wide" [class.is-invalid]="isMissing(vessel_name)">
          <span class="npp-label">Vessel name<span class="npp-req">*</span></span>
          <input class="npp-input" type="text" [(ngModel)]="vessel_name" [ngModelOptions]="{ standalone: true }"
            placeholder="e.g. Rhodes Star" />
        </label>

        <label class="npp-field" [class.is-invalid]="isMissing(vessel_imo)">
          <span class="npp-label">Vessel IMO<span class="npp-req">*</span></span>
          <input class="npp-input npp-input--num" type="number" [(ngModel)]="vessel_imo"
            [ngModelOptions]="{ standalone: true }" placeholder="7-digit IMO" />
        </label>

        <div class="npp-field" [class.is-invalid]="isMissing(segment)">
          <span class="npp-label" id="npp-segment-label">Segment<span class="npp-req">*</span></span>
          <mat-select class="npp-select" [(ngModel)]="segment" [ngModelOptions]="{ standalone: true }"
            placeholder="Select segment" [panelClass]="selectPanelClass" aria-labelledby="npp-segment-label">
            <mat-option *ngFor="let seg of segmentOptions" [value]="seg.value">{{ seg.label }}</mat-option>
          </mat-select>
        </div>
      </div>
    </section>

    <!-- Voyage -->
    <section class="npp-section">
      <h3 class="npp-section__title"><mat-icon>route</mat-icon>Voyage</h3>
      <div class="npp-grid">
        <label class="npp-field" [class.is-invalid]="isMissing(voyage_no)">
          <span class="npp-label">Voyage no.<span class="npp-req">*</span></span>
          <input class="npp-input" type="text" [(ngModel)]="voyage_no" [ngModelOptions]="{ standalone: true }"
            placeholder="Enter voyage number" />
        </label>

        <div class="npp-field" [class.is-invalid]="isMissing(cargo_type)">
          <span class="npp-label" id="npp-cargo-label">Cargo type<span class="npp-req">*</span></span>
          <mat-select class="npp-select" [(ngModel)]="cargo_type" [ngModelOptions]="{ standalone: true }"
            placeholder="Select cargo type" [panelClass]="selectPanelClass" aria-labelledby="npp-cargo-label">
            <mat-option *ngFor="let cargo of genericOilGradeOptions" [value]="cargo.value">{{ cargo.label }}</mat-option>
          </mat-select>
        </div>

        <div class="npp-field" [class.is-invalid]="isMissing(heating_type)">
          <span class="npp-label" id="npp-heating-label">Heating setup<span class="npp-req">*</span></span>
          <mat-select class="npp-select" [(ngModel)]="heating_type" [ngModelOptions]="{ standalone: true }"
            placeholder="Select heating setup" [panelClass]="selectPanelClass" aria-labelledby="npp-heating-label">
            <mat-option *ngFor="let ht of heatingTypeOptions" [value]="ht">{{ ht }}</mat-option>
          </mat-select>
        </div>
      </div>
    </section>

    <!-- Client & PIC -->
    <section class="npp-section">
      <h3 class="npp-section__title"><mat-icon>corporate_fare</mat-icon>Client &amp; ownership</h3>
      <div class="npp-grid">
        <div class="npp-field" [class.is-invalid]="isMissing(client)">
          <span class="npp-label-row">
            <span class="npp-label" id="npp-client-label">Client<span class="npp-req">*</span></span>
            <button type="button" class="npp-link" (click)="toggleCustomClient()">
              <mat-icon>{{ isCustomClient ? 'list' : 'edit' }}</mat-icon>
              {{ isCustomClient ? 'Choose from list' : 'Enter new client' }}
            </button>
          </span>
          <mat-select *ngIf="!isCustomClient" class="npp-select" [(ngModel)]="client"
            [ngModelOptions]="{ standalone: true }" [panelClass]="selectPanelClass" aria-labelledby="npp-client-label"
            [placeholder]="isLoadingClients ? 'Loading clients…' : 'Select client'">
            <mat-option *ngFor="let cl of clientOptions" [value]="cl">{{ cl }}</mat-option>
          </mat-select>
          <input *ngIf="isCustomClient" class="npp-input" type="text" [(ngModel)]="client"
            [ngModelOptions]="{ standalone: true }" placeholder="Enter client name" aria-labelledby="npp-client-label" />
        </div>

        <label class="npp-field" [class.is-invalid]="isMissing(pic)">
          <span class="npp-label">PIC<span class="npp-req">*</span></span>
          <input class="npp-input" type="text" [(ngModel)]="pic" [ngModelOptions]="{ standalone: true }"
            placeholder="Person in charge" />
        </label>
      </div>
    </section>

    <!-- Submits on Enter; the visible buttons live in the footer -->
    <button type="submit" hidden aria-hidden="true" tabindex="-1"></button>
  </form>

  <footer class="npp-foot">
    <span class="npp-foot__hint" [class.is-alert]="hasMissingFields">
      <mat-icon>{{ hasMissingFields ? 'error_outline' : 'info_outline' }}</mat-icon>
      {{ hasMissingFields ? 'Fill in the highlighted fields' : 'All fields are required' }}
    </span>
    <div class="npp-foot__actions">
      <button type="button" class="npp-btn npp-btn--ghost" (click)="cancel()" [disabled]="isSubmitting">Cancel</button>
      <button type="button" class="npp-btn npp-btn--primary" (click)="submitDateTime(true)" [disabled]="isSubmitting">
        <mat-icon [class.npp-spin]="isSubmitting">{{ isSubmitting ? 'autorenew' : 'add_task' }}</mat-icon>
        <span>{{ isSubmitting ? 'Registering…' : 'Register voyage' }}</span>
      </button>
    </div>
  </footer>
</div>
